import { gql } from "@apollo/client";

/**
 * GraphQL query to fetch all advertisers
 */
export const GET_ALL_ADVERTISERS_FOR_FILTER = gql`
  query AdvertiserMany($perPage: Int) {
    AdvertiserMany(perPage: $perPage) {
      items {
        _id
        name
      }
    }
  }
`;

/**
 * Creates advertiser filter options from GraphQL response data
 * 
 * @param data - The data returned from the GraphQL query
 * @returns Array of advertiser IDs and names formatted for filtering
 */
export const createAdvertiserFilters = (data: any) => {
  if (!data?.AdvertiserMany?.items) {
    return [];
  }
  
  return data.AdvertiserMany.items.map((advertiser: { _id: string, name: string }) => ({
    text: advertiser.name,
    value: advertiser._id,
  }));
};
